import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { Field } from "@/pages/admin/Field";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const URL_PLATFORMS = [["youtube", "YouTube"], ["instagram", "Instagram"], ["linkedin", "LinkedIn"], ["facebook", "Facebook"], ["threads", "Threads"]];

export const SocialSection = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);
  const load = () => adminApi.socialSettings().then(setData);
  useEffect(() => { load(); }, []);
  if (!data) return <p className="text-gmoaa-text-muted">Loading…</p>;

  const setUrl = (p, k) => (v) => setData((d) => ({ ...d, [p]: { ...d[p], [k]: v } }));
  const save = async () => {
    setSaving(true);
    try { await adminApi.updateSocialSettings(data); toast.success("Social links saved"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="mb-2 font-serif text-2xl font-semibold text-gmoaa-green">Social links</h2>
      <p className="mb-5 text-sm text-gmoaa-text-muted">These appear as "Follow us" buttons on the Home page counter strip. A button shows only when its link/number is filled and switched on. Links must start with https://.</p>

      <div className="space-y-3">
        {URL_PLATFORMS.map(([p, label]) => (
          <div key={p} className="flex items-end gap-3 rounded-xl border border-gmoaa-border-subtle bg-white p-4" data-testid={`social-row-${p}`}>
            <div className="flex-1"><Field label={`${label} URL`} value={data[p].url} onChange={setUrl(p, "url")} placeholder="https://…" testid={`social-${p}-url`} /></div>
            <div className="flex items-center gap-2 pb-2">
              <Switch checked={!!data[p].show} onCheckedChange={(v) => setUrl(p, "show")(v)} data-testid={`social-${p}-show`} />
              <Label className="text-xs text-gmoaa-text-muted">Show</Label>
            </div>
          </div>
        ))}

        <div className="space-y-3 rounded-xl border border-gmoaa-border-subtle bg-white p-4" data-testid="social-row-whatsapp">
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-gmoaa-green">WhatsApp Chat</p>
            <div className="flex items-center gap-2">
              <Switch checked={!!data.whatsapp.show} onCheckedChange={(v) => setUrl("whatsapp", "show")(v)} data-testid="social-whatsapp-show" />
              <Label className="text-xs text-gmoaa-text-muted">Show</Label>
            </div>
          </div>
          <Field label="WhatsApp number (with country code, digits only)" value={data.whatsapp.number} onChange={setUrl("whatsapp", "number")} placeholder="91XXXXXXXXXX" testid="social-whatsapp-number" />
          <Field label="Pre-filled message (optional)" value={data.whatsapp.message} onChange={setUrl("whatsapp", "message")} placeholder="Hello GMOAA, I need help with…" testid="social-whatsapp-message" />
        </div>
      </div>

      <Button onClick={save} disabled={saving} data-testid="social-save" className="mt-5 bg-gmoaa-green text-white hover:bg-gmoaa-green-hover">{saving ? "Saving…" : "Save social links"}</Button>
    </div>
  );
};
